import { gql, useQuery } from '@apollo/client';
import { UserContext, usePermission } from '@providers/userContextProvider';
import { generateClientNameString } from '@utils/generateClientNameString';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const FETCH_USER_NAME = ({
  canReadClientLowRiskPii,
}: {
  canReadClientLowRiskPii: boolean;
}) => gql`
  query fetchUserName($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        entityName # for NonIndividual Clients from Households route
        ${canReadClientLowRiskPii ? 'firstName' : ''}
        ${canReadClientLowRiskPii ? 'middleName' : ''}
        ${canReadClientLowRiskPii ? 'lastName' : ''}
      }
    }
  }
`;

export function ClientBreadcrumb() {
  const { t } = useTranslation();
  const canReadClientLowRiskPii = usePermission('read:client_low_risk_pii');
  const { userId: paramsUserId } = useParams();
  const { activeEntity } = useContext(UserContext);

  const userId = paramsUserId ?? activeEntity?.id;
  const { data } = useQuery(FETCH_USER_NAME({ canReadClientLowRiskPii }), {
    variables: { userId },
  });

  return data
    ? generateClientNameString(data.fetchUser?.user)
    : t('client:client');
}
